export default __webpack_public_path__ + "static/media/snacks.a0611d96.jpg";